module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOBAMAAADtZjDiAAAALVBMVEUAAADYRUXYRUXYRUXYRUXYRUXYRUXYRUXYRUXYRUXYRUXYRUXYRUXYRUXYRUWJwIOcAAAADnRSTlMAgvJ+U0EUDLLR0tPOscO97+kAAABmSURBVAjXY2Bgk1KamMDAwOD07t07FQYGlnet5RHvHBiSHgPF7NQY5BqMGYw5HjLMC5Azfsj6ikGvgPGdAPs7IM38zoD9EVDcTvAx60ugOkEGQaA6qD6gOVdB5sDNZWCTfnQwgQEAdUMjLyKp4TcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_fail.png
// module id = aEX+
// module chunks = 9